module.exports = __webpack_public_path__ + "static/media/yesyes.e0c291d3.jpg";